import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";
import { Module } from "../models/module";

@Injectable({
  providedIn: 'root'
})
export class ModuleService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'module/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllModules(filter: string, pagesize: number, pagenumber: number): Observable<Array<Module>> {
    return this.httpService.get(this.apiEndpoint + 'getAllModules?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  viewModule(LevelID?: string): Observable<Array<Module>> {
    return this.httpService.get(this.apiEndpoint + 'viewModule/' + (LevelID ? LevelID : '')).pipe(map((result: any) => {
      if (result.Success) {

        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveModule(level1: Module): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'saveModule/', level1).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteModule(LevelID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteModule/' + (LevelID ? LevelID : ''), LevelID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(Level_Name?: string,Level_Id?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?ModuleName=' + (Level_Name ? Level_Name : '')+ '&ModuleId=' + (Level_Id ? Level_Id : 0)).pipe(map((result: any) => {
        return result;
    }));
  }
}
